import H5Modal from '../../H5Modal/H5Modal'
import { CryptoPayment } from '../CryptoPayment'
import { useCryptoPaymentDataModal } from './CryptoPaymentModalDataProvider'
import { isNullOrUndefined } from '../../../services/helpers'
import { CryptoPaymentModalSuccess } from '../CryptoPaymentModalSuccess'

import classes from './cryptoPaymentModalData.module.scss'

export const CryptoPaymentModalData = () => {
  const {
    cryptoPaymentModalMode,
    withdrawalResponseData,
    resetWithdrawalResponseData,
    handleCloseCryptoPaymentModal
  } = useCryptoPaymentDataModal()

  return (
    <H5Modal
      showClose={isNullOrUndefined(withdrawalResponseData.amount)}
      closeIconDesign="overlay"
      show={!!cryptoPaymentModalMode}
      onHide={handleCloseCryptoPaymentModal}
      className={classes.cryptoPaymentModal}
      onExited={resetWithdrawalResponseData}
    >
      {isNullOrUndefined(withdrawalResponseData.amount) && <CryptoPayment />}
      {!isNullOrUndefined(withdrawalResponseData.amount) && <CryptoPaymentModalSuccess />}
    </H5Modal>
  )
}
